export interface Anime {
  id: string;
  name: string;
  category: string;
  tags: string[];
  rating: number;
  episodeCount: number;
  episodeMin: number;
  year: string;
  desc: string;
  cover: string;
  isHot?: boolean;
  isNew?: boolean;
}

export const animeCategories = [
  { key: "全部", label: "全部番剧", icon: "ri-apps-2-line" },
  { key: "泡面番", label: "泡面番", icon: "ri-restaurant-2-line" },
  { key: "三分钟短番", label: "三分钟短番", icon: "ri-timer-line" },
  { key: "日常搞笑", label: "日常搞笑", icon: "ri-emotion-laugh-line" },
  { key: "下饭番", label: "下饭番", icon: "ri-bowl-line" },
  { key: "治愈系", label: "治愈系", icon: "ri-heart-3-line" },
];

export const animeList: Anime[] = [
  {
    id: "qimu",
    name: "齐木楠雄的灾难",
    category: "日常搞笑",
    tags: ["超能力", "沙雕", "泡面"],
    rating: 9.3,
    episodeCount: 48,
    episodeMin: 5,
    year: "2016",
    desc: "拥有全知全能超能力的齐木楠雄只想当一个普通高中生，却总被身边这群性格炸裂的同学整得焦头烂额。每集五分钟的日常笑料密集，堪称下饭神番，摸鱼一口气刷完全季毫无压力。",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20portrait%20of%20a%20calm%20teenage%20boy%20with%20glasses%20and%20pink%20hair%20looking%20bored%2C%20superpower%20comedy%20theme%2C%20soft%20teal%20and%20cream%20color%20palette%2C%20clean%20minimal%20background%2C%20flat%20cute%20illustration%2C%20youthful%20cheerful%20mood&width=600&height=800&seq=qimu-cover-01&orientation=portrait",
    isHot: true,
  },
  {
    id: "xiaomai",
    name: "干物妹！小埋",
    category: "日常搞笑",
    tags: ["兄妹", "居家", "萌系"],
    rating: 9.0,
    episodeCount: 24,
    episodeMin: 7,
    year: "2015",
    desc: "在外是品学兼优的完美少女，回到家就变身成裹着仓鼠斗篷的干物妹小埋，喝可乐吃薯片打游戏。一部把「躺平人生」演得淋漓尽致的下饭番，看完只想立刻窝进沙发再来一集。",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20style%20illustration%20portrait%20of%20a%20lazy%20girl%20in%20a%20hamster%20blanket%20playing%20games%20with%20snacks%20at%20home%2C%20warm%20cozy%20orange%20tones%2C%20chibi%20style%2C%20clean%20minimal%20background%2C%20flat%20illustration%2C%20adorable%20youthful&width=600&height=800&seq=xiaomai-cover-01&orientation=portrait",
    isHot: true,
  },
  {
    id: "popzi",
    name: "POP子和PIPI美的日常",
    category: "泡面番",
    tags: ["毒舌", "玩梗", "神经"],
    rating: 8.7,
    episodeCount: 12,
    episodeMin: 3,
    year: "2018",
    desc: "两位金发姐妹花 POP子与PIPI美，用三分钟演尽全世界最无厘头的冷笑话和疯狂玩梗。画风魔性、剧情跳脱，是「三分钟短番」的教科书级代表，看之前请做好笑到拍桌的准备。",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20style%20illustration%20portrait%20of%20a%20smug%20cheeky%20girl%20character%20with%20bright%20yellow%20and%20pink%20colors%2C%20comedic%20expression%2C%20playful%20pop%20art%20anime%20poster%2C%20warm%20coral%20background%2C%20clean%20minimal%2C%20bold%20flat%20colors%2C%20youthful&width=600&height=800&seq=popzi-cover-01&orientation=portrait",
    isNew: true,
  },
  {
    id: "natsume",
    name: "夏目友人帐",
    category: "治愈系",
    tags: ["妖怪", "温馨", "日常"],
    rating: 9.4,
    episodeCount: 13,
    episodeMin: 8,
    year: "2008",
    desc: "少年夏目贵志能看见妖怪，继承外婆的「友人帐」后，与妖怪们展开了温暖又寂寞的相遇。这部治愈系短番节奏舒缓、配乐空灵，是深夜emo时最好的安慰剂，适合细水长流地慢慢看。",
    cover: "https://readdy.ai/api/search-image?query=serene%20anime%20style%20illustration%20portrait%20of%20a%20gentle%20teenage%20boy%20with%20yellow-brown%20hair%20standing%20in%20a%20green%20field%20with%20a%20small%20white%20cat%20spirit%2C%20healing%20fantasy%20mood%2C%20soft%20green%20and%20cream%20colors%2C%20clean%20minimal%2C%20warm&width=600&height=800&seq=natsume-cover-01&orientation=portrait",
    isHot: true,
  },
  {
    id: "huangye",
    name: "摇曳露营△",
    category: "治愈系",
    tags: ["露营", "美食", "慢生活"],
    rating: 9.1,
    episodeCount: 12,
    episodeMin: 6,
    year: "2018",
    desc: "冬日的富士山脚下，少女们独自或结伴露营，煮一锅热气腾腾的咖喱，看星空慢慢亮起。这部下饭番把「慢生活」做到了极致，安静治愈到让人也想立刻背起帐篷出发。",
    cover: "https://readdy.ai/api/search-image?query=cozy%20anime%20style%20illustration%20portrait%20of%20a%20girl%20camping%20in%20mountains%20with%20tent%20and%20marshmallow%20by%20campfire%2C%20outdoor%20healing%20atmosphere%2C%20teal%20and%20warm%20amber%20palette%2C%20flat%20cute%20illustration%2C%20clean%20minimal&width=600&height=800&seq=huangye-cover-01&orientation=portrait",
    isNew: true,
  },
  {
    id: "kangna",
    name: "康娜的日常",
    category: "三分钟短番",
    tags: ["龙娘", "校园", "萌系"],
    rating: 8.9,
    episodeCount: 12,
    episodeMin: 4,
    year: "2017",
    desc: "小仓鼠大小的龙娘康娜在人类世界的上学日常，懵懂又好奇，每一帧都在发射萌系光波。短短几分钟就能让你整个人被治愈，是「三分钟短番」里最值得一看的萌番代表。",
    cover: "https://readdy.ai/api/search-image?query=adorable%20anime%20style%20illustration%20portrait%20of%20a%20small%20dragon%20girl%20with%20white%20hair%20and%20horns%20wearing%20school%20uniform%2C%20healing%20cute%20mood%2C%20soft%20teal%20and%20cream%20colors%2C%20chibi%20style%2C%20clean%20minimal%2C%20gentle&width=600&height=800&seq=kangna-cover-01&orientation=portrait",
    isNew: true,
  },
  {
    id: "bihai",
    name: "碧蓝之海",
    category: "下饭番",
    tags: ["潜水", "爆笑", "大学生"],
    rating: 9.0,
    episodeCount: 12,
    episodeMin: 7,
    year: "2018",
    desc: "一群大学生在潜水社里的沙雕日常，前一秒还在热血介绍潜水，下一秒就疯闹着拼酒裸奔。笑点密集到喘不过气，是公认的「下饭番」天花板，吃饭时千万别看，容易笑喷。",
    cover: "https://readdy.ai/api/search-image?query=funny%20anime%20style%20illustration%20portrait%20of%20a%20muscular%20college%20boy%20with%20diving%20goggles%20laughing%20loudly%2C%20comedy%20diving%20theme%2C%20teal%20blue%20and%20cream%20colors%2C%20flat%20cute%20illustration%2C%20clean%20minimal%2C%20youthful&width=600&height=800&seq=bihai-cover-01&orientation=portrait",
    isHot: true,
  },
  {
    id: "xiasong",
    name: "这个美术社大有问题！",
    category: "三分钟短番",
    tags: ["社团", "恋爱", "搞笑"],
    rating: 8.6,
    episodeCount: 12,
    episodeMin: 5,
    year: "2016",
    desc: "美术社里，社长沉迷画二次元老婆，副会长是个天才却只想睡懒觉，只有宇佐美认真暗恋着那个对美术毫无兴趣的社员。短小精悍的社团日常，酸酸甜甜又好笑。",
    cover: "https://readdy.ai/api/search-image?query=cheerful%20anime%20style%20illustration%20portrait%20of%20an%20art%20club%20girl%20with%20paintbrush%20and%20messy%20paint%2C%20comedic%20cute%20mood%2C%20warm%20coral%20and%20yellow%20palette%2C%20flat%20illustration%2C%20clean%20minimal%20background%2C%20youthful&width=600&height=800&seq=xiasong-cover-01&orientation=portrait",
  },
  {
    id: "qianbei",
    name: "关于前辈很烦人的事",
    category: "下饭番",
    tags: ["职场", "甜", "治愈"],
    rating: 8.5,
    episodeCount: 12,
    episodeMin: 6,
    year: "2021",
    desc: "娇小的职场新人五十岚，遇上总爱「照顾」她的高大前辈武田。两个性格反差巨大的人在工作日常里慢慢靠近，糖分超标又轻松治愈，是最适合下班后配饭看的下饭番。",
    cover: "https://readdy.ai/api/search-image?query=sweet%20anime%20style%20illustration%20portrait%20of%20a%20cheerful%20young%20office%20worker%20woman%20with%20a%20tall%20senior%20colleague%20behind%20her%2C%20workplace%20slice%20of%20life%2C%20soft%20warm%20orange%20and%20pink%20colors%2C%20flat%20cute%2C%20clean%20minimal&width=600&height=800&seq=qianbei-cover-01&orientation=portrait",
  },
];